import { AxiosInstance } from "axios"
import { ChunkedArrayResponse } from "../../../oneportal/units/types/ChunkedArrayResponse"
import { ChunkedLookupResponse } from "../../../oneportal/units/types/ChunkedLookupResponse"

export const getLookupPC07 = async (
  api: AxiosInstance
): Promise<ChunkedArrayResponse<ChunkedLookupResponse> | undefined> => {
  try {
    const res = await api.get<ChunkedArrayResponse<ChunkedLookupResponse>>("/api/admin/PC07/GetLookup")
    return res.data
  } catch (err) {}
}

export const getLookupPC07NotFilter = async (
    api: AxiosInstance
): Promise<ChunkedArrayResponse<ChunkedLookupResponse> | undefined> => {
    try {
        const res = await api.get<ChunkedArrayResponse<ChunkedLookupResponse>>("/api/admin/PC07/GetLookupNotFilter")
        return res.data
    } catch (err) { }
}
